import { getCurrentPageCfi } from "./load-status/selectors";

export function getCurrentPageBreak(state) {
  return state.nav.pageBreak;
}

export function getCurrentPageBreakLabel(state) {
  return state.nav.pageBreak.label;
}

export function hasNextContentDoc(state) {
  return state.nav.hasNextContentDoc;
}

export function hasPreviousContentDoc(state) {
  return state.nav.hasPreviousContentDoc;
}

function getCurrentScrollCfi(state) {
  return state.nav.pageScroll?.cfi;
}

export function getCurrentScrollTop(state) {
  return state.nav.pageScroll?.scrollTop || 0;
}

export function getCurrentScrollHeight(state) {
  return state.nav.pageScroll?.scrollHeight || 0;
}

export function getCurrentCfi(state) {
  const page = getCurrentPageCfi(state);
  const scroll = getCurrentScrollCfi(state);
  if (page) {
    // Guarantee we have a doc location, even if the scroll event is delayed
    return `${page}!${scroll || "/4"}`;
  }
}

// This is kept in sync by the middleware
export function getUniversalUrl(state) {
  return state.nav.universalUrl;
}

export function universalUrlIsReady(state) {
  return !!getUniversalUrl(state);
}

export function hasPageScrolled(state) {
  return state.nav.pageHasScrolled.hasScrolled;
}
